import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import EventActivityYear from '../../states-year/Events/EventActivityYear';
import EventResponseYear from '../../states-year/Events/EventResponseYear';
import EventStatusYear from '../../states-year/Events/EventStatusYear';
import TotalYear from '../../states-year/Events/TotalYear';
import StudentsYear from '../../states-year/Events/StudentsYear';
import InvitationsByMonth from '../../states-year/Events/InvitationsByMonth';
import InvitationCreatorYear from '../../states-year/Events/InvitationCreatorYear';
import InvitationDeclinerYear from '../../states-year/Events/InvitationDeclinerYear';
import InvitationDeclineReasonYear from '../../states-year/Events/InvitationDeclineReasonYear';

export default function Events(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Events"
        columns={1}
      >
        {/*<EventActivityYear {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <EventResponseYear {...params} />
          <EventStatusYear {...params} />
        </div>
        <EventActivityYear {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <TotalYear {...params} titleOnly={true} />
          <StudentsYear {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Invitations - Events"
        columns={1}
      >
        <InvitationsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <InvitationCreatorYear {...params} />
          <InvitationDeclinerYear {...params} />
        </div>
        <InvitationDeclineReasonYear {...params} />
      </LazyMetrics>
    </>
  );
}
